
import React from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';

interface TrialExpirationBannerProps {
  daysLeft: number;
}

export function TrialExpirationBanner({ daysLeft }: TrialExpirationBannerProps) {
  const navigate = useNavigate();
  
  // Don't show the banner if days left is greater than 3
  if (daysLeft > 3) return null;
  
  return (
    <div className={`w-full ${daysLeft <= 1 ? 'bg-red-50 border-red-400' : 'bg-yellow-50 border-yellow-400'} border-l-4 p-4 mb-4 rounded-md`}>
      <div className="flex items-center justify-between">
        <div className="flex items-start">
          <AlertCircle className={`h-5 w-5 ${daysLeft <= 1 ? 'text-red-500' : 'text-yellow-500'} mr-3 mt-0.5`} />
          <div>
            <h3 className={`font-medium ${daysLeft <= 1 ? 'text-red-800' : 'text-yellow-800'}`}>
              {daysLeft <= 0 
                ? "Your trial has expired" 
                : daysLeft === 1 
                  ? "Your trial expires today!" 
                  : `Your trial expires in ${daysLeft} days`}
            </h3>
            <p className={`text-sm ${daysLeft <= 1 ? 'text-red-700' : 'text-yellow-700'}`}>
              {daysLeft <= 0 
                ? "Please upgrade to a paid plan to continue accessing premium features." 
                : "Upgrade now to ensure uninterrupted access to all features."}
            </p>
          </div>
        </div>
        <Button 
          variant={daysLeft <= 1 ? "destructive" : "default"}
          size="sm" 
          className={daysLeft <= 1 ? "" : "bg-yellow-500 hover:bg-yellow-600 text-white"}
          onClick={() => navigate('/subscription/plans')}
        >
          Upgrade Now
        </Button>
      </div>
    </div>
  );
}
